import { render, staticRenderFns } from "./YuChenProduct.vue?vue&type=template&id=3da2363b&scoped=true&"
import script from "./YuChenProduct.vue?vue&type=script&lang=js&"
export * from "./YuChenProduct.vue?vue&type=script&lang=js&"
import style0 from "./YuChenProduct.vue?vue&type=style&index=0&id=3da2363b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2363b",
  null
  
)

/* custom blocks */
import block0 from "./YuChenProduct.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports